export default {
  "update-time-bucket-success": {
    EN: "Time bucket renamed successfully!",
  },
  "update-time-bucket-failure": {
    EN: "Failed to rename time bucket",
  },
  "delete-time-bucket-success": {
    EN: "Time bucket deleted successfully!",
  },
  "delete-time-bucket-failure": {
    EN: "Failed to delete time bucket",
  },
  "create-time-bucket-success": {
    EN: "Time bucket created successfully!",
  },
  "create-time-bucket-failure": {
    EN: "Failed to create time bucket",
  },
  "update-time-entry-success": {
    EN: "Time entry updated successfully!",
  },
  "update-time-entry-failure": {
    EN: "Failed to update time entry",
  },
  "delete-time-entry-success": {
    EN: "Time entry deleted successfully",
  },
  "delete-time-entry-failure": {
    EN: "Failed to delete time entry",
  },
  "create-time-entry-success": {
    EN: "Time entry created successfully",
  },
  "create-time-entry-failure": {
    EN: "Failed to create time entry",
  },
};
